import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export const DEFAULT_MAP_MARKER = 'assets/images/marker.svg';

export class MapElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  enablePopup: boolean;
  lat: number;
  lng: number;
  title = '';
  content = '';
  location = '';
  marker = DEFAULT_MAP_MARKER;
  markerHeight = 50;
  markerWidth = 30;
  markerOpacity = 1;

  constructor(lat?: number, lng?: number) {
    this.lat = lat || 30.236074;
    this.lng = lng || -81.510359;
  }

  static normalizeInPlace(element: MapElement): MapElement {
    const pureElement = new MapElement();

    element.enablePopup = element.enablePopup ?? pureElement.enablePopup;
    element.lat = element.lat ?? pureElement.lat;
    element.lng = element.lng ?? pureElement.lng;
    element.title = element.title ?? pureElement.title;
    element.content = element.content ?? pureElement.content;
    element.location = element.location ?? pureElement.location;
    element.marker = element.marker || pureElement.marker;
    element.markerHeight = element.markerHeight ?? pureElement.markerHeight;
    element.markerWidth = element.markerWidth ?? pureElement.markerWidth;
    element.markerOpacity = element.markerOpacity ?? pureElement.markerOpacity;

    return element;
  }
}
